import React from "react";
import { Helmet } from "react-helmet";
import PropTypes from "prop-types";
import { langToSlug, BASE_URL } from "../utils/langUrl";


const SEOHead = ({ title, description, location, lang = "en" }) => {
  // Ensure path starts with / if not empty, and doesn't end with / unless it is root
  // We need to parse the logical path from the current location.pathname
  // e.g. /ja/company -> /company
  // e.g. /company -> /company
  let rawPath = (location && location.pathname) || "";
  
  const langs = ["/en", "/ja", "/zh-tw", "/zh"];
  let cleanPath = rawPath;
  for (const l of langs) {
      if (cleanPath.toLowerCase().startsWith(l)) {
          // Verify it's a full segment match (e.g. /ja/ or /ja at end)
          if (cleanPath.length === l.length || cleanPath[l.length] === "/") {
              cleanPath = cleanPath.substring(l.length);
              break;
          }
      }
  }
  if (!cleanPath.startsWith("/")) cleanPath = "/" + cleanPath;
  // Handle root case carefully: if it becomes just "", make it "/"
  if (cleanPath === "") cleanPath = "/";

  
  // Construct language specific URLs using lowercase URL slugs
  const getUrl = (internalLang) => {
    // Always use lowercase slug in URL path
    const slug = langToSlug(internalLang);
    const prefix = `/${slug}`;
    // If path is root '/', result is '/en/' or '/ja/'
    if (cleanPath === "/" || cleanPath === "") {
        return `${BASE_URL}${prefix}/`;
    }
    // Avoid double slash if cleanPath starts with /
    return `${BASE_URL}${prefix}${cleanPath}`.replace(`${BASE_URL}//`, `${BASE_URL}/`);
  };

  const currentCanonical = getUrl(lang);

  return (
    <Helmet>
      <html lang={lang} />
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      
      {/* Canonical — single source of truth */}
      <link rel="canonical" href={currentCanonical} />
      <meta property="og:url" content={currentCanonical} />

      {/* hreflang tags — use BCP-47 casing for hreflang attribute values */}
      <link rel="alternate" hreflang="en" href={getUrl("en")} />
      <link rel="alternate" hreflang="ja" href={getUrl("ja")} />
      <link rel="alternate" hreflang="zh-TW" href={getUrl("zh-TW")} />
      <link rel="alternate" hreflang="x-default" href={getUrl("en")} />
    </Helmet>
  );
};

SEOHead.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  location: PropTypes.object.isRequired, // React Router location object
  lang: PropTypes.string,
};

export default SEOHead;
